import React        from 'react';
import Translations from '../../../utils/Translations';

function BoughtLabel () {
	return (
		<span className="video-grid__item--label --inverse">
			<i className='icon --icon-success-rounded-full h-mr-2'></i>
			{Translations.get('Bought')}
		</span>
	);
}

export default BoughtLabel;
